import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isLoggedIn as isLoggedInSelector } from '../../../store/auth/selectors';
import { fetchShopAssignments } from '../../../store/shop/actions';
import { hasLoadedAssignments, isLoadingAssignments } from '../../../store/shop/selectors';

class AssignmentLoader extends React.Component {
  componentDidMount() {
    const { hasPreviouslyLoaded } = this.props;
    if (!hasPreviouslyLoaded) {
      this.loadIfRequired();
    }
  }

  componentDidUpdate(prevProps) {
    const { isLoggedIn } = this.props;
    const { isLoggedIn: wasLoggedIn } = prevProps;
    if (!wasLoggedIn && isLoggedIn) {
      this.loadIfRequired();
    }
  }

  loadIfRequired = () => {
    const { clubId, isLoading, loadAssignments, isLoggedIn } = this.props;
    if (isLoggedIn && !isLoading) {
      loadAssignments(clubId);
    }
  };

  render() {
    return null;
  }
}

AssignmentLoader.propTypes = {
  clubId: PropTypes.number.isRequired,
  hasPreviouslyLoaded: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  loadAssignments: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isLoading: isLoadingAssignments(state),
  hasPreviouslyLoaded: hasLoadedAssignments(state),
  isLoggedIn: isLoggedInSelector(state),
});

const dispatchToProps = {
  loadAssignments: fetchShopAssignments,
};

export default connect(mapStateToProps, dispatchToProps)(AssignmentLoader);
